export const hasCreateProjectPermission = (userEntitlements) => {
    if (userEntitlements === undefined || userEntitlements?.dataPermissions === undefined) {
        return false;
    }
    else {
        return validatePermission(userEntitlements?.primaryPartyType, userEntitlements?.dataPermissions?.energyFlowProjects?.create);
    }
};
export const hasUpdateProjectPermission = (userEntitlements) => {
    if (userEntitlements === undefined || userEntitlements?.dataPermissions === undefined) {
        return false;
    }
    else {
        return validatePermission(userEntitlements?.primaryPartyType, userEntitlements?.dataPermissions?.energyFlowProjects?.update);
    }
};
export const validatePermission = (primaryPartyType, permission) => {
    const hasPermission = primaryPartyType?.toUpperCase() === "CAT" && permission !== undefined;
    return hasPermission;
};
export const getUserPartyNumber = (userEntitlements) => {
    if (userEntitlements === undefined || userEntitlements?.dataPermissions === undefined) {
        return "";
    }
    else {
        const permission = userEntitlements?.dataPermissions?.energyFlowProjects?.view;
        const partyFilter = permission?.filterConditions.filter((fc) => fc?.partyNumbers !== undefined);
        return partyFilter?.[0]?.partyNumbers?.[0];
    }
};
export const hasEnergyFlowLinksCreatePermission = (userEntitlements) => {
    if (userEntitlements === undefined || userEntitlements?.dataPermissions === undefined) {
        return false;
    } //remove this condition once energyFlowLinks permission is added to entitlements
    else if (userEntitlements?.dataPermissions?.energyFlowLinks === undefined) {
        return true;
    }
    else {
        return userEntitlements?.dataPermissions?.energyFlowLinks?.create !== undefined;
    }
};
export const hasEnergyFlowLinksUpdatePermission = (userEntitlements) => {
    if (userEntitlements === undefined || userEntitlements?.dataPermissions === undefined) {
        return false;
    } //remove this condition once energyFlowLinks permission is added to entitlements
    else if (userEntitlements?.dataPermissions?.energyFlowLinks === undefined) {
        return true;
    }
    else {
        return userEntitlements?.dataPermissions?.energyFlowLinks?.update !== undefined;
    }
};
export const hasEnergyFlowLinksViewPermission = (userEntitlements) => {
    if (userEntitlements === undefined || userEntitlements?.dataPermissions === undefined) {
        return false;
    } //remove this condition once energyFlowLinks permission is added to entitlements
    else if (userEntitlements?.dataPermissions?.energyFlowLinks === undefined) {
        return true;
    }
    else {
        return userEntitlements?.dataPermissions?.energyFlowLinks?.view !== undefined;
    }
};
